import React, { useState, useEffect } from "react";
import styles from "./styles.m.css";
import Iframe from "react-iframe";
import Icon from "../../atoms/icon";
import PropTypes from "prop-types";
import { get } from "lodash";
import SkeletonLoading from "../skeleton-screen-loading";
import { DeepBI, GA } from "../../../integrations";
function RegisterDataWall(props) {
  const handleCloseDatawall = get(props, ["handleCloseDatawall"], () => null);
  const story = get(props, ["story"], () => null);
  const segment = get(props, ["segment"], () => null);
  const [ready, setReady] = useState(true);
  useEffect(() => {
    DeepBI.pingFreeDatawallEventTrigger(story);
    GA.registerPageEvent("FreeDatawallDisplayed", segment, global.location.href);
    DeepBI.FreeDatawall(story, "freedatawall", "", "Free");
  }, []);

  const handleChange = () => {
    handleCloseDatawall();
    GA.customEvent("Datawall-closed", segment, "closed");
  };

  const hideSpinner = () => {
    setReady(false);
  };

  return (
    <React.Fragment>
      <div className={`${styles["iframe-outer"]} ${ready ? styles["ac"] : styles["ec"]}`}>
        <div className={styles["skeloton"]}>
          <SkeletonLoading />
        </div>
        <div className={styles["close-div"]} onClick={() => handleChange()}>
          <Icon type="cancel" />
        </div>
        <Iframe
          frameBorder="0"
          onLoad={() => hideSpinner()}
          className={`${styles["iframe-outer"]}`}
          src={`https://login.vikatan.com/datawall_login?&path=${encodeURIComponent(
            global && global.location && global.location.href
          )}`}
          loading="lazy"
        />
      </div>
    </React.Fragment>
  );
}
RegisterDataWall.propTypes = {
  handleCloseDatawall: PropTypes.func
};
export default RegisterDataWall;
